import React, { useEffect, useState } from "react";
import { AlumniMedia, AlumniNews } from "../../Data";
import AlumniCards from "../../components/AlumniCards";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default function EventsReunionSection() {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  // Detect screen size changes
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {" "}
      <section className=" responsive-padding mt-8 laptopSm:mt-0 mb-8 laptopSm:mb-16 grid gap-6 w-full">
        <h1 className="font-montserrat font-bold text-2xl md:text-3xl laptopSm:text-4xl text-text-dark leading-4 ">
          Events and Reunions
        </h1>
        <div className="w-full overflow-hidden relative pb-10">
          <Carousel
            arrows={false}
            centerMode={false}
            className=""
            itemClass="px-2 "
            containerClass=""
            dotListClass="absolute "
            draggable
            focusOnSelect={false}
            infinite={false}
            keyBoardControl
            minimumTouchDrag={80}
            pauseOnHover={true}
            renderArrowsWhenDisabled={false}
            renderButtonGroupOutside={false}
            renderDotsOutside
            responsive={{
              desktop: {
                breakpoint: {
                  max: 3000,
                  min: 1024,
                },
                items: 3,
              },
              mobile: {
                breakpoint: {
                  max: 464,
                  min: 0,
                },
                items: 1,
              },
              tablet: {
                breakpoint: {
                  max: 1024,
                  min: 464,
                },
                items: 2,
              },
            }}
            rewind
            rewindWithAnimation={false}
            rtl={false}
            shouldResetAutoplay
            showDots={true}
            sliderClass=""
            slidesToSlide={1}
            swipeable
          >
            {AlumniNews.map((newsItem) => (
              <div key={newsItem.id} className="w-full flex h-full">
                <AlumniCards newsItem={newsItem} />
              </div>
            ))}
          </Carousel>
        </div>

        <div className="overflow-hidden mt-4 lg:mt-10">
          <Carousel
            additionalTransfrom={0}
            arrows
            centerMode={false}
            className=""
            itemClass="px-4" // Ensure each item takes the full height
            containerClass=""
            dotListClass=""
            draggable
            focusOnSelect={false}
            infinite={true}
            keyBoardControl
            minimumTouchDrag={80}
            pauseOnHover={true}
            renderArrowsWhenDisabled={false}
            renderButtonGroupOutside={false}
            renderDotsOutside={false}
            responsive={{
              desktop: {
                breakpoint: {
                  max: 3000,
                  min: 1024,
                },
                items: 3,
              },
              mobile: {
                breakpoint: {
                  max: 464,
                  min: 0,
                },
                items: 1,
              },
              tablet: {
                breakpoint: {
                  max: 1024,
                  min: 464,
                },
                items: 2,
              },
            }}
            rewind
            rewindWithAnimation={false}
            rtl={false}
            shouldResetAutoplay
            showDots={false}
            sliderClass=""
            slidesToSlide={2}
            swipeable
          >
            {AlumniMedia.map((media, index) => (
              <div key={index} className="w-full h-[198px] lg:h-[296px] ">
                <img
                  src={media}
                  alt={media}
                  className="w-full h-full rounded-lg object-cover object-center"
                />
              </div>
            ))}
          </Carousel>
        </div>
      </section>
    </>
  );
}
